import React from 'react';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import MileageParticipationGuide from '@di-shared/features/mileage/ecomileage/MileageParticipationGuide';
import MileageIntro from '@di-shared/features/mileage/intro/MileageIntro';

interface MileageParticipationGuidePageProps {
  vin: string;
}

function MileageParticipationGuidePage({vin}: MileageParticipationGuidePageProps) {
  return (
    <>
      <ScrollToTopOnMount />
      <MileageParticipationGuide vin={vin} />
    </>
  );
}

export default MileageParticipationGuidePage;
